import React from 'react';
import { Input, Checkbox, Switch, Radio, Typography, Space, Card, Button } from 'antd';

const { TextArea } = Input;

const TextQuestion = ({ question, required, value, onChange }) => (
  <div>
    <Typography.Text strong>
      {question} {required && <span style={{ color: 'red' }}>*</span>}
    </Typography.Text>
    <TextArea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Enter your answer..."
      style={{ marginTop: 8 }}
      rows={3}
    />
  </div>
);

const MultipleChoiceQuestion = ({ question, required, options, value = [], onChange }) => (
  <div>
    <Typography.Text strong>
      {question} {required && <span style={{ color: 'red' }}>*</span>}
    </Typography.Text>
    <Checkbox.Group
      value={value}
      onChange={onChange}
      style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {options.map((option, index) => (
        <Checkbox key={index} value={option}>
          {option}
        </Checkbox>
      ))}
    </Checkbox.Group>
  </div>
);

const BooleanQuestion = ({ question, required, value, onChange }) => (
  <div>
    <Typography.Text strong>
      {question} {required && <span style={{ color: 'red' }}>*</span>}
    </Typography.Text>
    <div style={{ marginTop: 8 }}>
      <Switch checked={value} onChange={onChange} />
      <Typography.Text style={{ marginLeft: 8 }}>{value ? 'Yes' : 'No'}</Typography.Text>
    </div>
  </div>
);

const RatingQuestion = ({ question, required, value, onChange }) => (
  <div>
    <Typography.Text strong>
      {question} {required && <span style={{ color: 'red' }}>*</span>}
    </Typography.Text>
    <div style={{ marginTop: 16 }}>
      <Radio.Group value={value} onChange={(e) => onChange(e.target.value)}>
        <Space direction="horizontal">
          {[1, 2, 3, 4, 5].map((rating) => (
            <Radio key={rating} value={rating}>
              {rating}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </div>
  </div>
);

export const CustomForm = ({ params }) => {
  const [formData, setFormData] = React.useState({});

  const mockForm = [
    {
      id: 1,
      enabled: true,
      type: 'text',
      question: "What's you name?",
      required: true,
    },
    {
      id: 2,
      enabled: true,
      type: 'multiple_choice',
      question: 'What do you prefer to play? Select multiple options.',
      required: false,
      options: ['Footbal', 'Soccer', 'Basketball'],
    },
    {
      id: 3,
      enabled: true,
      type: 'boolean',
      question: 'Are you +18 years old?',
      required: true,
    },
    {
      id: 4,
      enabled: true,
      type: 'rating',
      question: 'In a scale of 1 to 5, how was you visit experience?',
      required: true,
    },
  ];

  const handleInputChange = (id, value) => {
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const renderQuestion = (question) => {
    const commonProps = {
      question: question.question,
      required: question.required,
      value: formData[question.id],
      onChange: (value) => handleInputChange(question.id, value),
    };

    switch (question.type) {
      case 'text':
        return <TextQuestion {...commonProps} />;
      case 'multiple_choice':
        return <MultipleChoiceQuestion {...commonProps} options={question.options} />;
      case 'boolean':
        return <BooleanQuestion {...commonProps} />;
      case 'rating':
        return <RatingQuestion {...commonProps} />;
      default:
        return null;
    }
  };

  const handleSubmit = () => {
    console.log('data', formData);
  };

  return (
    <section style={{ maxWidth: 600, margin: '0 auto', padding: 24 }}>
      <Typography.Title level={3}>Audit Form</Typography.Title>
      <Space direction="vertical" size={24} style={{ width: '100%' }}>
        {mockForm
          .filter((question) => question.enabled)
          .map((question, index) => (
            <Card key={index} style={{ borderRadius: 12 }}>
              {renderQuestion(question)}
            </Card>
          ))}
      </Space>
      <Button onClick={handleSubmit}>Send</Button>
    </section>
  );
};
